import { getAffairOwnerName, formatAffairAmount, formatAffairDate, formatAffairStage, getAffairPartnerName } from '../affairFormatters';

const read = (affair, ...keys) => keys.map((key) => affair?.[key]).find((value) => value !== undefined && value !== null);



const SummaryItem = ({ label, value }) => (
  <div className="affair-summary-band__item">
    <span>{label}</span>
    <strong>{value || '—'}</strong>
  </div>
);

export default function AffairSummaryBand({ affair }) {
  return (
    <section className="affair-summary-band" aria-label="Résumé de l’affaire">
      <SummaryItem label="Partenaire" value={getAffairPartnerName(affair)} />
      <SummaryItem label="Étape" value={formatAffairStage(affair.stage)} />
      <SummaryItem label="Montant" value={formatAffairAmount(affair.estimatedAmount)} />
      <SummaryItem label="Échéance" value={formatAffairDate(affair.responseDeadline)} />
      <SummaryItem label="Responsable" value={getAffairOwnerName(affair)} />
      <SummaryItem label="Dernière activité" value={formatAffairDate(read(affair, 'lastActivityAt', 'last_activity_at'))} />
    </section>
  );
}
